import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { ESentEmailType } from '../../types/sentEmail';
import { ESubtitleOffset, SubtitleLayout } from '../SubtitleLayout';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EmailSentInfo(_ref) {
  var viewData = _ref.viewData;
  var content = React.useMemo(function () {
    if (viewData.type === ESentEmailType.Registration) {
      return /*#__PURE__*/_jsxs(ArticleParagraph1, {
        children: ["\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u043E\u0447\u0442\u0443\xA0\u2014 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u0438\u0441\u044C\u043C\u043E \u043D\u0430\xA0", /*#__PURE__*/_jsx("span", {
          className: styles['email'],
          children: viewData.email
        })]
      });
    } else {
      return /*#__PURE__*/_jsxs(ArticleParagraph1, {
        children: ["\u041F\u0438\u0441\u044C\u043C\u043E \u0441\xA0\u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0435\u0439 \u043F\u043E\xA0\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044E \u043F\u0430\u0440\u043E\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430\xA0\u0430\u0434\u0440\u0435\u0441", ' ', /*#__PURE__*/_jsx("span", {
          className: styles['email'],
          children: viewData.email
        })]
      });
    }
  }, [viewData]);
  return /*#__PURE__*/_jsx(SubtitleLayout, {
    offset: ESubtitleOffset.XL,
    children: content
  });
}